import { useContext } from 'react';

import { FeatureFlagsContext } from './feature-flags-context';
import type { FeatureFlagKey } from './feature-flags-context';

// ----------------------------------------------------------------------

/**
 * Returns whether a feature flag is enabled for the current company.
 *
 * - Returns `true` while flags are still loading (fail-open, no flash of hidden content).
 * - Returns `true` for unknown keys (un-flagged features are always visible).
 *
 * Usage:
 * ```tsx
 * const enabled = useFeatureFlag('report-builder');
 * if (!enabled) return null;
 * ```
 */
export function useFeatureFlag(key: FeatureFlagKey): boolean {
  const { flags, loading } = useContext(FeatureFlagsContext);
  if (loading) return true;
  return flags[key] ?? true;
}

export function useFeatureFlagsContext() {
  return useContext(FeatureFlagsContext);
}
